import { render, staticRenderFns } from "./timelineItem.vue?vue&type=template&id=42577748&scoped=true&"
import script from "./timelineItem.vue?vue&type=script&lang=js&"
export * from "./timelineItem.vue?vue&type=script&lang=js&"
import style0 from "./timelineItem.vue?vue&type=style&index=0&id=42577748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42577748",
  null
  
)

export default component.exports